function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { getNestedValue } from '../objectUtils';
export default function DropdownFormField(_ref) {
  let {
    fieldName,
    label,
    onChange,
    values,
    required,
    valueAttributeName,
    textAttributeName,
    valueFn,
    multiple = false,
    labelMd = 6,
    fieldMd = undefined,
    ...selectProps
  } = _ref;
  const {
    t
  } = useTranslation();
  textAttributeName ||= valueAttributeName;
  if (valueAttributeName && valueFn) {
    console.error('SelectFormField received both valueFn and valueAttribute props. This should not happen.');
  }
  let options = [];
  if (valueFn) {
    options = (values || []).map((value, index) => valueFn(value, index));
  } else {
    options = (values || []).map((value, index) => /*#__PURE__*/React.createElement("option", {
      key: value.id || `option-index-${index}`,
      value: typeof value === 'string' ? value : getNestedValue(value, valueAttributeName)
    }, typeof value === 'string' ? t(value) : t(getNestedValue(value, textAttributeName))));
  }
  return /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: labelMd
  }, t(`${label || fieldName}`), required ? '*' : ''), /*#__PURE__*/React.createElement(Col, {
    md: fieldMd
  }, /*#__PURE__*/React.createElement(Form.Control, _extends({
    as: "select",
    name: fieldName,
    onChange: e => {
      multiple ? onChange(Array.from(e.target.selectedOptions).map(o => o.value), e.target.selectedOptions) : onChange(e.target.value);
    },
    size: "md",
    multiple: multiple
  }, selectProps), /*#__PURE__*/React.createElement("option", {
    value: null
  }), options)));
}